import React, { useCallback, useEffect, useState } from "react";
import memoizeOne from 'memoize-one';
import uniqueId from "lodash.uniqueid";
import Input from "./UI/InputAdmin";
import Select from "./UI/SelectAdmin";
import ServiceMenu from "./UI/ServiceMenu";

import { servicesv1, SlotTypev1 } from "../../../entities/Datav1";

import {
  getRequestParams,
  service,
  service as axiosService
} from "../../../tools/service";

import "react-notifications-component/dist/theme.css";
import { store } from "react-notifications-component";
import _, { map } from "lodash";


interface MultiInputProps {
    values?: string[];
    onChange: (newValues: string[]) => void;
    editInfoService?: service[]
    serverDataReady?: boolean;
    errors?: any;
}


export interface InputConfig {
    id: string;
    value: string;
}

export interface CurrentOtherJobType {
    active: boolean;
}


export interface service {
    id: string
    serviceType: string;
    serviceFriendlyName: InputConfig;
    slotTypes: SlotType[];
    active: boolean;
}

export interface SlotType {
    id: string
    slotType: string;
    slotFriendlyName: InputConfig;
    jobTypes: JobType[];
}
export interface JobType {
    id: string
    groupName: string;
    jobClass: string;
    jobType: string;
    jobTypeDesc: string;
    jobFriendlyName: InputConfig;
}

const emptySlot = (): SlotType => ({
    id: uniqueId("slot-"),
    slotType: "",
    slotFriendlyName: emptyInput(),
    jobTypes: emptyJobType()
})

const emptyJobType = (): JobType[] => (
    [
        {
            id: uniqueId("job-"),
            groupName: "",
            jobClass: "",
            jobType: "",
            jobTypeDesc: "",
            jobFriendlyName: emptyInput()
        }
    ]
)

const emptySingleJobType = (): JobType => (
    {
        id: uniqueId("job-"),
        groupName: "",
        jobClass: "",
        jobType: "",
        jobTypeDesc: "",
        jobFriendlyName: emptyInput()
    }
)

const emptyInput = (): InputConfig => ({
    id: uniqueId('input-'),
    value: '',
})
const emptyService = (data: string): service => ({
    id: "service-" + data,
    active: true,
    serviceType: data,
    serviceFriendlyName: emptyInput(),
    slotTypes: [
        {
            id: uniqueId("slot-"),
            slotType: '',
            slotFriendlyName: emptyInput(),
            jobTypes: [
                {
                    id: uniqueId("job-"),
                    groupName: "",
                    jobClass: "",
                    jobType: "",
                    jobTypeDesc: "",
                    jobFriendlyName: emptyInput()
                }
            ]
        }
    ]
});



/**
 * editInfoService
 * @param props
 * @returns
 */
const Service = (props: MultiInputProps) => {
    const { editInfoService } = props;
    const { serverDataReady } = props;
    const [slotType, setSlotType] = useState([]);
    const [serviceConfig, setServiceConfig] = useState<service[]>([]);
    const [multiService, setMultiService] = useState<service[]>([]);
    const [currentService, setCurrentService] = useState("");
    const [cleanService, setCleanService] = useState(false)
    const [jobOptions, setJobOptions] = useState({} as { [key: string]: JobType[] })
    const [disabledPlumbing, setDisabledPlumbing] = useState(false);
    const [disabledHVAC, setDisabledHVAC] = useState(false);
    const [disabledElectrical, setDisabledElectrical] = useState(false);
    const [disabledRoofing, setDisabledRoofing] = useState(false);
    const [disabledOther, setDisabledOther] = useState(false);
    const [currentServiceButton, setCurrentServiceButton] = useState("Plumbing");
    const [CurrentOtherJobType, SetCurrentOtherJobType] = useState({ active: false });
    const [labelButtonService, setLabelButtonService] = useState("Add New Service");
    const [edit, setEdit] = useState(true);
    const [disableUpdateButton, setdisableUpdateButton] = useState(false);


    const [currentSlotTypeSelected, setCurrentSlotTypeSelected] = useState({} as { [key: string]: any })
    const [currentJobTypeSelected, setCurrentJobTypeSelected] = useState({} as { [key: string]: any })
    const [slotInputId, setSlotInputId] = useState({} as { [key: string]: any })
    const [activeMenu, setActiveMenu] = useState(true);
    const [activeServiceMap, setActiveServiceMap] = useState(new Map())

    const showNotification = (title: string, message: string, type: any) => {
        store.addNotification({
            title: title,
            message: message,
            type: type,
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
                duration: 5000,
                onScreen: true
            }
        });
    }

    // handle change pf service
    const handleOnChange = (data: string, flag?: string) => {
        if (flag === "fromBtn") setEdit(true)
        localStorage.setItem("openService", "1")
        if (labelButtonService.includes("Update")) setLabelButtonService("Add New Service")
        setCurrentSlotTypeSelected({})
        setCurrentJobTypeSelected({})
        setCleanService(true);
        setCurrentService(data);
        setCurrentServiceButton(data)
        handleAddService(data);
    }

    const getSlotTypes = () => {

        const userInfo = getRequestParams() as any
        const parameters = {
            "filter": "",
            "max": "",
            "orderBy": "",
            "styleNo": "",
            "styleOptions": "",
            "groupNames": "ALL",
            "swCompanyId": localStorage.getItem("currentCompanySelected"),
            "swapiUrl": userInfo["swapiUrl"]
        };
        axiosService.post("api/swapi/timeslotDefaultsQuery", parameters).then(response => {
            setSlotType(response.data.sort());
            localStorage.setItem("slotTypes", JSON.stringify(response.data.sort()))
        }).catch(error => {
            return console.log(error);
        });
    }

    const getJobTypes = (url: string, parameters: object, slotSelectedv2: string, filterBySlotTypes?: string) => {
        return new Promise((resolve, reject) => {
            axiosService.post(url, parameters)
                .then(response => {
                    resolve([slotSelectedv2, response.data])
                }).catch(error => {
                    reject(console.log(error));
                });
        })
    }

    function compare(a: JobType, b: JobType) {
        if (a.jobTypeDesc.toUpperCase() < b.jobTypeDesc.toUpperCase()) {
            return -1;
        }
        if (a.jobTypeDesc.toUpperCase() > b.jobTypeDesc.toUpperCase()) {
            return 1;
        }
        return 0;
    }


    const slotOnChange = (slotSelectedv2: string) => {

        const filterBySlotType = slotType[Number(slotSelectedv2)];
        const userInfo = getRequestParams() as any

        const url = 'api/swapi/timeslotDetailQuery';
        const data = {
            "filter": "",
            "max": "",
            "orderBy": "",
            "styleNo": "",
            "styleOptions": "",
            "groupName": filterBySlotType,
            "swCompanyId": localStorage.getItem("currentCompanySelected"),
            "swapiUrl": userInfo["swapiUrl"]
        };
        return getJobTypes(url, data, slotSelectedv2);
    }

    const memoizedSlotOnChange = memoizeOne(slotOnChange);

    useEffect(() => {
        if (window.location.pathname.includes("/edit")) {
            let defaultServiceMap = new Map();
            editInfoService?.forEach(value => {
                defaultServiceMap.set(value.serviceType, { service: value, allocated: true });
            })

            setSlotType(JSON.parse(localStorage.getItem("slotTypes") || '[]'))
            setMultiService([])
            setMultiService(editInfoService ?? [])
            let servicesCopy = _.cloneDeep(editInfoService);
            localStorage.setItem('servicesOriginal', JSON.stringify(servicesCopy)); //use a local storage copy as backup to rollback changes if the user clicks cancel service
            handleRemoveService("")
            setCleanService(true)
            setServiceConfig([])
            setCurrentService("")
            setActiveServiceMap(defaultServiceMap);
        }
    }, [editInfoService])



    useEffect(() => {
        if (!window.location.pathname.includes("/edit")) {
            handleOnChange(currentServiceButton)
            localStorage.removeItem("service")
        }
    }, [])

    useEffect(() => {
        if (serviceConfig.length > 0 && cleanService && edit) {
            handleRemoveService("")
            setCleanService(false)
        }
        switchEnabledToDisabled()

    }, [currentService, multiService, serviceConfig])

    useEffect(() => {

        getSlotTypes();
        let defaultServiceMap = new Map();
        if (editInfoService?.length === 0) {
            setMultiService([])
            setDisabledPlumbing(false);
            setDisabledHVAC(false);
            setDisabledElectrical(false);
            setDisabledRoofing(false);
            setDisabledOther(false);
            editInfoService?.forEach(value => {
                defaultServiceMap.set(value.serviceType, { service: value, allocated: true });
            })
            if (serviceConfig.length === 0)
                handleOnChange("Plumbing", "fromBtn")
        }
        setActiveServiceMap(defaultServiceMap);
    }, [editInfoService])


    /**
     *  This method handle the service modification.
     *  It will only modify if serviceConfig is modified
     *  action can be edit or delete
     */
    const handleServiceMenuUpdate = useCallback(
        (serviceId: string, serviceType: string) => {
            setEdit(false)
            handleOnChange(serviceType)
            setLabelButtonService("Update " + serviceType)
            localStorage.setItem('openService', "1")

            const localSlotTypes = (JSON.parse(localStorage.getItem('slotTypes') || '[]') as []).sort()
            console.log("multiservice", multiService)
            const services = [...multiService]
            const currentServicesEdit = services.filter(el => el.serviceType === serviceType)
            setServiceConfig(currentServicesEdit)

            const promise: Promise<any>[] = []
            let currentSlotTypeInMap = {} as any;
            let currentJobTypeInMap = {} as any;

            currentServicesEdit.forEach(service => {
                service.slotTypes.forEach(slot => {
                    const id = slot.id.includes("slot") ? slot.id.split("-")[1] : slot.id
                    slot.jobTypes.forEach(job => {
                        currentJobTypeInMap[job.jobTypeDesc + "-" + id] = job.jobTypeDesc
                    })
                    const findPosInSlotType = localSlotTypes.findIndex(el => el === slot.slotType).toString()
                    currentSlotTypeInMap[id] = slotType[Number(findPosInSlotType)]
                    promise.push(handleChangeSelectSlotEdit(findPosInSlotType, slot.id, localSlotTypes, currentServicesEdit))

                })
            })
            setCurrentSlotTypeSelected(currentSlotTypeInMap)
            setCurrentJobTypeSelected(currentJobTypeInMap)
            let newMap = {} as any;
            Promise.all(promise).then(response => {
                response.forEach(data => {
                    newMap[data[0]] = data[1].sort(compare);
                })
                setJobOptions(newMap)
            })
        },
        [serviceConfig]
    )

    /**
     *  This method handle the service modification.
     *  It will only modify if serviceConfig is modified
     *  action can be edit or delete
     */
    const handleDeleteServiceMenu =
        (serviceId: string, serviceType: string) => {

            let defaultServiceMap = activeServiceMap;
            setLabelButtonService("Update " + serviceType)
            const services = [...multiService]
            services.forEach((currentService) => {
                if (currentService.serviceType == serviceType) {
                    currentService.active = false;
                }
            });

            // comment this code to support cancel delete
            const removedService = services.filter( currentService => (currentService.active))
            setActiveServiceMap(defaultServiceMap)
            setServiceConfig(services);
            setdisableUpdateButton(false)
            setEdit(true)
            handleOnChange(serviceType)
            setLabelButtonService("Add New Service")
            setCurrentSlotTypeSelected({})
            setCurrentJobTypeSelected({})
            setServiceConfig([])
            setCurrentService("")
            setdisableUpdateButton(false)
            localStorage.removeItem('openService')
            localStorage.setItem('servicesOriginal',JSON.stringify(removedService));
            localStorage.setItem('service', JSON.stringify(removedService));
        }

    /**
     * This method render the service control with job and slot drop down
     * @returns
     */
    function renderServiceMenu() {
        return multiService?.map((service, index, s) => {
            return (
                <ServiceMenu
                    key={index}
                    serviceName={service.serviceType}
                    slotTypes={service.slotTypes}
                    handleEditService={() => handleServiceMenuUpdate(service.id, service.serviceType)}
                    handleDeleteService={() => handleDeleteServiceMenu(service.id, service.serviceType)}
                    serviceId={service.id}
                    serviceType={service.serviceType}
                    services={s}
                    otherServiceType={CurrentOtherJobType.active}
                    activeServiceMap={activeServiceMap}
                />
            )
        })
    }


    const handleChangeSelectSlotEdit = (slotSelectedv2: string, slotId: string, localSlotTypes: [], services: service[]) => {
        const slotSelectedValue = localSlotTypes[Number(slotSelectedv2)]
        addSlotSelectToServiceEdit(slotSelectedValue, slotId, services)
        return slotOnChange(slotSelectedv2);
    }

    const addSlotSelectToServiceEdit = (slotSelected: string, slotId: string, services: service[]) => {
        let tempCurrentService = [...services];

        const getPositionCurrentService = services.findIndex(el => el.serviceType === services[0].serviceType)

        const getPositionSlotType = tempCurrentService[getPositionCurrentService].slotTypes.findIndex(el => el.id === slotId)
        tempCurrentService[getPositionCurrentService].slotTypes[getPositionSlotType].slotType = slotSelected ?? ""
        setServiceConfig(tempCurrentService)
    }

    const handleChangeSelectSlot = (slotSelectedv2: string, slotId: string) => {

        const id = Number(slotId.split("-")[1])
        const slotSelectedValue = slotType[Number(slotSelectedv2)]
        const isSlotSelectedValueIn = Object.values(currentSlotTypeSelected).indexOf(slotSelectedValue)
        const isSlotInputId = Object.values(slotInputId).indexOf(id)
        const isSlotInputValue = Object.values(slotInputId).map(val => {
            return val
        })

        if (isSlotSelectedValueIn === -1 || (isSlotInputId >= 0 && isSlotInputValue !== slotSelectedValue)) {
            setCurrentSlotTypeSelected({
                ...currentSlotTypeSelected,
                [id]: slotType[Number(slotSelectedv2)]
            })
            setSlotInputId({
                ...slotInputId,
                [id]: slotType[Number(slotSelectedv2)]
            })


            addSlotSelectToService(slotSelectedValue, slotId)
            memoizedSlotOnChange(slotSelectedv2).then((data: any) => {
                setJobOptions({ ...jobOptions, [data[0]]: data[1].sort(compare) });
            });
        } else {
            showNotification("SlotType", "You have already selected this slot type", "warning")
        }

    }

    const addSlotSelectToService = (slotSelected: string, slotId: string) => {
        let tempCurrentService = [...serviceConfig];
        const getPositionCurrentService = serviceConfig.findIndex(el => el.serviceType === currentService)
        const getPositionSlotType = tempCurrentService[getPositionCurrentService].slotTypes.findIndex(el => el.id === slotId)
        tempCurrentService[getPositionCurrentService].slotTypes[getPositionSlotType].slotType = slotSelected ?? ""
        setServiceConfig(tempCurrentService)
    }
    const defaultValue = (descript: string) => {
        let answ = -1;
        slotType.forEach((val, index) => {
            if (val === descript) answ = index
        })
        return answ
    }


    /**
     * This method render all sevices box with details
     * @param services
     * @param currentService
     * @returns
     */
    function renderService(services: service[], currentService: service) {
        return (services.map((service, index) => {
            return renderServiceDetail(index, services, currentService);
        }))
    }

    /**
     *  This method will render the service detail when edit is clicked
     *  Name, slot type and job type
     * @param index
     * @param services
     * @param currentService
     * @returns
     */
    const renderServiceDetail = (index: number, services: service[], currentService: service) => {
        if (currentService.active) {
            return (
                <div key={index} className="flex flex-col">
                    {CurrentOtherJobType.active ? "" : renderOtherServiceTextBox(index, services[index])}
                    {CurrentOtherJobType.active ? "" : renderSlotTypes(currentService.slotTypes)}
                </div>
            )
        }
        else {
            return (
                <div key={index} className="flex flex-col" />
            )

        }
    }

    // This method render the textbox in other service
    function renderOtherServiceTextBox(index: React.Key, service: service) {
        return (

            <div>
                {currentService === "Other" && index === 0 ?
                    <Input
                        key={service.serviceFriendlyName.id}
                        value={service.serviceFriendlyName.value}
                        id={service.serviceFriendlyName.id}
                        onChange={(value) => handleotherService?.(value, service.serviceFriendlyName.id)}
                        onRemove={() => handleRemoveOtherService(service.id)}
                        onAdd={handleAddService}
                        placeholder="New Service Type"
                        flag={index}
                        len={service.serviceFriendlyName.value.length}
                        whichOnChange={"Other"}
                        slotId=""
                        jobId=""
                    /> : null}
            </div>

        )
    }


    /**
     *  This metho dwill render the Slots
     * @param SlotTypes
     * @returns
     */
    function renderSlotTypes(SlotTypes: SlotType[]) {
        return (SlotTypes.map((slot, index) => {

            return (
                <div key={index} className="flex flex-col">
                    <div className={` flex flex-col md:flex-row  ${currentService === "Other" ? "mb-2" : ""} `} >
                        <Select
                            id={slot.id}
                            description="Select Slot Type"
                            className={`w-full rounded  custom-input-successware pl-3 md:w-7/12 md:mr-2`}
                            populate={slotType}
                            type={"slot"}
                            value={defaultValue(slot.slotType)}
                            onChange={(val) => handleChangeSelectSlot(val, slot.id)}
                        />
                        <Input
                            key={slot.slotFriendlyName.id}
                            value={slot.slotFriendlyName.value}
                            id={slot.slotFriendlyName.id}
                            onChange={(value) => handleChange?.(value, slot.id)}
                            onRemove={() => handleRemoveSlotSelection(slot.id)}
                            onAdd={handleAddSlot}
                            placeholder="Change Slot Name"
                            flag={index}
                            len={SlotTypes.length}
                            whichOnChange={"slot"}
                            slotId=""
                            jobId=""
                        />
                    </div>
                    {renderJobTypes(slot.jobTypes, slot.id, index)}
                </div>
            )
        }))

    }
    const defaultValueJob = (array: JobType[], desc: string) => {
        let temp = -1;
        array?.forEach((val, index) => {
            if (val.jobTypeDesc === desc) temp = index;
        })
        return temp;
    }
    function renderJobTypes(JobType: JobType[], slotId: string, slotIdv2: number) {
        let tempCurrentService = [...serviceConfig];
        const getPositionCurrentService = serviceConfig.findIndex(el => el.serviceType === currentService)
        let getPositionSlotType = tempCurrentService[getPositionCurrentService].slotTypes.findIndex(el => el.id === slotId)
        if (getPositionSlotType === -1) getPositionSlotType = 0
        const slotSelectedRender = tempCurrentService[getPositionCurrentService].slotTypes[getPositionSlotType].slotType ?? ""
        const slotPosition = slotType.findIndex(el => el === slotSelectedRender)


        return (
            JobType?.map((job, index) => {
                return (
                    <div key={index} className="flex flex-col md:flex-row ml-14">
                        <Select
                            key={job.id}
                            id={job.id}
                            description="Select Job Type"
                            className="w-full rounded  custom-input-successware pl-3 md:w-1/2 md:mr-2"
                            populateJob={jobOptions[slotPosition] ?? []}
                            valueSlot={defaultValueJob(jobOptions[slotPosition], job.jobTypeDesc)}
                            type={"job"}
                            onChange={(value) => handleJobOnChange(value, job.id, slotId, slotPosition)}
                        />
                        <Input
                            key={job.jobFriendlyName.id}
                            value={job.jobFriendlyName.value}
                            id={job.jobFriendlyName.id}
                            onChangeJob={(value) => handleChangeSlot?.(value, slotId, job.id)}
                            onRemove={() => handleRemoveJobSelection(slotId, job.id)}
                            onAdd={() => handleAddJob(slotId)}
                            placeholder="Change Job Name"
                            flag={index}
                            len={JobType.length}
                            whichOnChange={"job"}
                            slotId={slotId}
                            jobId={job.id}
                        />
                    </div>
                );
            })
        )
    }

    const allowButtonAddService = (): boolean => {
        let allowAddNewService = true;
        serviceConfig.forEach(service => {
            service.slotTypes.forEach(slot => {
                if (slot.slotType.length === 0) {
                    allowAddNewService = false;
                }
                slot.jobTypes.forEach(job => {
                    if (job.jobTypeDesc.length === 0) {
                        allowAddNewService = false;
                    }
                })
            })
        })
        return allowAddNewService;
    }

    const allowButtonAddServiceOther = (): boolean => {
        let allowAddNewService = true;
        serviceConfig.forEach(service => {
            if (service.serviceType !== "Other") return true
            if (CurrentOtherJobType.active && service.serviceType === "Other") {
                return true;
            }
            else {
                allowAddNewService = true;
            }

        })
        return allowAddNewService;
    }

    /**
     * This method is to avoid adding same service twice
     * @param services
     * @param type
     * @returns
     */
    const avoidDuplicates = (services: service[], type: string) => {
        const temp = JSON.parse(localStorage.getItem(type) || '[]') as service[]
        if (services.length == 0) {
            return true;
        }
        let answ = false;
        temp.map(val => {
            if (val.serviceType === services[0].serviceType) {
                answ = true
            }
        })
        return answ

    }

    const cancelService = () => {
        setLabelButtonService("Add New Service")
        setCurrentSlotTypeSelected({})
        setCurrentJobTypeSelected({})
        setServiceConfig([])
        setCurrentService("")
        setdisableUpdateButton(false)
        let updateLocalService = JSON.parse(localStorage.getItem("servicesOriginal") || '[]') as service[]
        setMultiService(updateLocalService)
        SetCurrentOtherJobType({ active: false })
        localStorage.removeItem('openService')
    }


    /**
     *  This method will add new service
     */
    const handleAddNewService = () => {
        let allowAddNewService = allowButtonAddService()
        const allowedAddNewServiceOther = allowButtonAddServiceOther()
        if (allowAddNewService && allowedAddNewServiceOther) {
            setLabelButtonService("Add New Service")
            setCurrentSlotTypeSelected({})
            setCurrentJobTypeSelected({})
            let multiServiceTemp = [...multiService]

            const newService: servicesv1[] = serviceConfig?.reduce((items, it) => {
                const slotTypes: SlotTypev1[] = it.slotTypes?.reduce((stypes, st) => {
                    stypes.push({
                        slotType: st.slotType,
                        slotFriendlyName: ((st.slotFriendlyName.value && st.slotFriendlyName.value.length > 0) ? st.slotFriendlyName.value : st.slotType) ?? "",
                        jobTypes: st.jobTypes.map((val) => ({
                            groupName: val.groupName,
                            jobClass: val.jobClass,
                            jobType: val.jobType,
                            jobTypeDesc: val.jobTypeDesc,
                            jobFriendlyName: (val.jobFriendlyName.value && val.jobFriendlyName.value.length > 0 ? val.jobFriendlyName.value : val.jobTypeDesc) ?? ""
                        }))
                    })
                    return stypes
                }, [] as SlotTypev1[])
                items.push({
                    serviceType: it.serviceType,
                    serviceFriendlyName: (it.serviceFriendlyName.value && it.serviceFriendlyName.value.length > 0) ? it.serviceFriendlyName.value : it.serviceType,
                    slotTypes
                })

                return items
            }, [] as servicesv1[])

            if (avoidDuplicates(serviceConfig, "service")) {
                let updateLocalService = JSON.parse(localStorage.getItem("service") || '[]') as service[]
                multiServiceTemp = updateLocalService.filter(val => {
                    return val.serviceType !== currentService;
                })
                multiServiceTemp.push(...serviceConfig)
            } else {
                let removeDuplicateService = multiServiceTemp.filter(service => {
                    return (service.serviceType != currentService)
                } );
                multiServiceTemp = removeDuplicateService;
                multiServiceTemp.push(...serviceConfig)
            }
            setServiceConfig([])
            setMultiService(multiServiceTemp)
            localStorage.setItem('servicesOriginal', JSON.stringify(multiServiceTemp));
            props.errors["slotTypes"] = 0
            localStorage.setItem('service', JSON.stringify(multiServiceTemp))
            setCurrentService("")
            localStorage.removeItem('openService')
        }
    }


    const handleChange = useCallback(
        (value: string, id: string) => {

            let tempCurrentService = [...serviceConfig];
            const getPositionCurrentService = serviceConfig.findIndex(el => el.serviceType === currentService)
            const getPositionSlotType = tempCurrentService[getPositionCurrentService].slotTypes.findIndex(el => el.id === id)
            tempCurrentService[getPositionCurrentService].slotTypes[getPositionSlotType].slotFriendlyName.value = value ?? ""
            setServiceConfig(tempCurrentService)

        },
        [serviceConfig]
    )
    const handleotherService = useCallback(
        (value: string, id: string) => {
            let tempCurrentService = [...serviceConfig];
            const getPositionCurrentService = serviceConfig.findIndex(el => el.serviceType === currentService)
            tempCurrentService[getPositionCurrentService].serviceFriendlyName.value = value ?? ""
            setServiceConfig(tempCurrentService)

        },
        [serviceConfig]
    )

    const handleChangeSlot = useCallback(
        (value: string, slotId: string, jobId: string) => {
            let tempCurrentService = [...serviceConfig];
            const getPositionCurrentService = serviceConfig.findIndex(el => el.serviceType === currentService)
            const getPositionSlotType = tempCurrentService[getPositionCurrentService].slotTypes.findIndex(el => el.id === slotId)
            const getPositionJobType = tempCurrentService[getPositionCurrentService].slotTypes[getPositionSlotType].jobTypes.findIndex(el => el.id === jobId)
            tempCurrentService[getPositionCurrentService].slotTypes[getPositionSlotType].jobTypes[getPositionJobType].jobFriendlyName.value = value ?? ""
            setServiceConfig(tempCurrentService)
        },
        [serviceConfig]
    )
    const handleJobOnChange = (value: string, jobId: string, slotId: string, slotIdv2: number) => {
        let tempCurrentService = [...serviceConfig];
        const getPositionCurrentService = serviceConfig.findIndex(el => el.serviceType === currentService)
        const getPositionSlotType = tempCurrentService[getPositionCurrentService].slotTypes.findIndex(el => el.id === slotId)
        const getPositionJobType = tempCurrentService[getPositionCurrentService].slotTypes[getPositionSlotType].jobTypes.findIndex(el => el.id === jobId)

        const id = Number(slotId.split("-")[1])

        const isJobInputValue = Object.values(currentJobTypeSelected).indexOf(jobOptions[slotIdv2][Number(value)].jobTypeDesc)
        if (isJobInputValue === -1) {
            setCurrentJobTypeSelected({
                ...currentJobTypeSelected,
                [jobOptions[slotIdv2][Number(value)].jobTypeDesc + "-" + id]: jobOptions[slotIdv2][Number(value)].jobTypeDesc
            });
            tempCurrentService[getPositionCurrentService].slotTypes[getPositionSlotType].jobTypes[getPositionJobType].groupName = jobOptions[slotIdv2][Number(value)].groupName ?? ""
            tempCurrentService[getPositionCurrentService].slotTypes[getPositionSlotType].jobTypes[getPositionJobType].jobClass = jobOptions[slotIdv2][Number(value)].jobClass ?? ""
            tempCurrentService[getPositionCurrentService].slotTypes[getPositionSlotType].jobTypes[getPositionJobType].jobType = jobOptions[slotIdv2][Number(value)].jobType ?? ""
            tempCurrentService[getPositionCurrentService].slotTypes[getPositionSlotType].jobTypes[getPositionJobType].jobTypeDesc = jobOptions[slotIdv2][Number(value)].jobTypeDesc ?? ""
            setServiceConfig(tempCurrentService)
        } else {
            showNotification("JobTypes", "You have already selected " + jobOptions[slotIdv2][Number(value)].jobTypeDesc, "warning")
        }
    }

    const handleAddService = (data: string) => {
        setServiceConfig([...serviceConfig, emptyService(data)]);
        setCurrentService(data);
    }
    const handleAddSlot = () => {
        const tempCurrentService = [...serviceConfig];
        const getPositionCurrentService = serviceConfig.findIndex(el => el.serviceType === currentService)
        tempCurrentService[getPositionCurrentService].slotTypes.push(emptySlot());
        setSlotInputId({})
        setServiceConfig(tempCurrentService)
    }
    const handleAddJob = (id: string) => {
        const tempCurrentService = [...serviceConfig];
        const getPositionCurrentService = serviceConfig.findIndex(el => el.serviceType === currentService)
        const getPositionSlotType = tempCurrentService[getPositionCurrentService].slotTypes.findIndex(el => el.id === id)
        tempCurrentService[getPositionCurrentService].slotTypes[getPositionSlotType].jobTypes.push(emptySingleJobType())
        setServiceConfig(tempCurrentService)
    }



    const handleRemoveService = (data: string) => {
        const tempServiceConfig = [...serviceConfig]
        let newRenderService = tempServiceConfig.filter(service => {
            return service.id === 'service-' + currentService;
        })
        setServiceConfig(newRenderService)
    }


    // This code will remove the 'Top level of other service'
    const handleRemoveOtherService = (data: string) => {
        const tempServiceConfig = [...multiService]
        let newRenderService = tempServiceConfig.filter(service => {
            return service.id === data;
        })

        newRenderService.forEach(currentService => {
            currentService.slotTypes.forEach(slottype => {
                slottype.jobTypes.forEach(jobType => {
                    handleRemoveJobSelection(slottype.id, jobType.id);
                })
                handleRemoveSlotSelection(slottype.id);
            })
        })

        SetCurrentOtherJobType({ active: true });
        setServiceConfig(newRenderService)
    }


    /**
     * Handle removal from slot selection box
     * @param slotID
     */
    const handleRemoveSlotSelection = (slotID: string) => {

        const tempCurrentService = [...serviceConfig];
        const currentServicePosition = serviceConfig.findIndex(el => el.serviceType === currentService)
        const matchedSlotPosition = tempCurrentService[currentServicePosition].slotTypes.findIndex(el => el.id === slotID)

        const idSlot = slotID.includes("-") ? slotID.split("-")[1] : slotID
        const newInputSlot = { ...slotInputId }
        const newCurrentSlotType = { ...currentSlotTypeSelected }

        //remove element from array
        delete newInputSlot[idSlot]

        // remove current slot type from slotType Array
        delete newCurrentSlotType[idSlot]

        setSlotInputId(newInputSlot)
        setCurrentSlotTypeSelected(newCurrentSlotType)

        let newCurrentJobTypeSelected = {} as { [key: string]: any }

        Object.entries(currentJobTypeSelected).forEach(val => {
            if (!val[0].includes(idSlot)) {
                newCurrentJobTypeSelected[val[0]] = val[1]
            }
        })

        //update jobType
        setCurrentJobTypeSelected(newCurrentJobTypeSelected)
        tempCurrentService[currentServicePosition].slotTypes.splice(matchedSlotPosition, 1)
        setServiceConfig(tempCurrentService)
    }

    /**
     * Handle removal from job selection box
     * @param slotId
     * @param jobId
     */
    const handleRemoveJobSelection = (slotId: string, jobId: string) => {
        // serviceConfig contains all servces
        const tempCurrentService = [...serviceConfig];
        const positionofService = serviceConfig.findIndex(el => el.serviceType === currentService)
        const positionOfSlot = tempCurrentService[positionofService].slotTypes.findIndex(el => el.id === slotId)
        const positionofMatchedJobType = tempCurrentService[positionofService].slotTypes[positionOfSlot].jobTypes.findIndex(el => el.id === jobId)
        const currentJobSelections = tempCurrentService[positionofService].slotTypes[positionOfSlot].jobTypes[positionofMatchedJobType].jobTypeDesc
        tempCurrentService[positionofService].slotTypes[positionOfSlot].jobTypes.splice(positionofMatchedJobType, 1)
        const id = slotId.includes("slot") ? slotId.split("-")[1] : slotId
        let newCurrentJobTypeSelected = {} as { [key: string]: any }

        // remove selected value from drop down
        Object.entries(currentJobTypeSelected).forEach(val => {
            if (!val[0].includes(currentJobSelections + "-" + id)) {
                newCurrentJobTypeSelected[val[0]] = val[1]
            }
        })

        setCurrentJobTypeSelected(newCurrentJobTypeSelected)

        // update the current service with job removed
        setServiceConfig(tempCurrentService)
    }



    const switchEnabledToDisabled = () => {
        const multiServiceTempAvailability = [...multiService];
        multiServiceTempAvailability.forEach(service => {
            if (service.serviceType === "Plumbing") setDisabledPlumbing(service.active);
            if (service.serviceType === "HVAC") setDisabledHVAC(service.active);
            if (service.serviceType === "Electrical") setDisabledElectrical(service.active);
            if (service.serviceType === "Roofing") setDisabledRoofing(service.active);
            if (service.serviceType === "Other") setDisabledOther(service.active);
        })
    }


    return (
        <div className=" justify-center  max-w-5xl flex-row md:flex lg:ml-72 mb-3">
            <div className="w-full flex justify-center md:justify-start  md:w-1/4">
                <p className="text-lg font-bold text-customBlue">Service</p>
            </div>
            <div className={`m-3 md:w-3/4 mt-6 ${props.errors["slotTypes"] === 1 ? "custom-picker-error" : ""}`}>
                {multiService ? renderServiceMenu() : null}
                <p className="custom-service-label">Service Type</p>
                <div className="flex flex-col justify-center mt-3">
                    <div className="w-full flex flex-col   justify-center md:flex-row md:justify-start  ">
                        <div className="w-full flex justify-center md:w-5/12 md:justify-start">
                            <label className={`p-2 mr-3   mb-3 w-1/2 md:w-1/2  inline-flex items-center ${"Plumbing" !== currentService ? "custom-radio-button-service" : "custom-radio-button-service-selected"} `}   >
                                <input
                                    checked={"Plumbing" === currentService ? true : false}
                                    type="radio"
                                    onChange={e => handleOnChange("Plumbing", "fromBtn")}
                                    className="form-radio" name="serviceType" value="Plumbing"
                                    disabled={disabledPlumbing}
                                />
                                <span className={`ml-2 ${"Plumbing" !== currentService ? "custom-service-label" : "custom-service-label-selected"} `}>Plumbing</span>
                            </label>
                            <label className={`p-2   mb-3 w-1/2 md:w-1/2 inline-flex items-center ${"HVAC" !== currentService ? "custom-radio-button-service" : "custom-radio-button-service-selected"}`}>
                                <input
                                    checked={"HVAC" === currentService ? true : false}
                                    disabled={disabledHVAC}
                                    type="radio" onChange={e => handleOnChange("HVAC", "fromBtn")} className="form-radio" name="serviceType" value="HVAC" />
                                <span className={`ml-2 ${"HVAC" !== currentService ? "custom-service-label" : "custom-service-label-selected"} `}>HVAC</span>
                            </label>
                        </div>
                        <div className="  w-full flex  justify-center md:ml-3 md:w-5/12 md:justify-start">
                            <label className={`p-2 mr-3   mb-3 w-1/2 md:w-1/2  inline-flex items-center ${"Electrical" !== currentService ? "custom-radio-button-service" : "custom-radio-button-service-selected"} `}>
                                <input
                                    checked={"Electrical" === currentService ? true : false}
                                    disabled={disabledElectrical}
                                    type="radio" onChange={e => handleOnChange("Electrical", "fromBtn")} className="form-radio" name="serviceType" value="Electrical" />
                                <span className={`ml-2 ${"Electrical" !== currentService ? "custom-service-label" : "custom-service-label-selected"}`}>Electrical</span>
                            </label>
                            <label className={`p-2   mb-3 w-1/2 md:w-1/2  inline-flex items-center ${"Roofing" !== currentService ? "custom-radio-button-service" : "custom-radio-button-service-selected"}`}>
                                <input
                                    checked={"Roofing" === currentService ? true : false}
                                    disabled={disabledRoofing}
                                    type="radio" onChange={e => handleOnChange("Roofing", "fromBtn")} className="form-radio" name="serviceType" value="Roofing" />
                                <span className={`ml-2 ${"Roofing" !== currentService ? "custom-service-label" : "custom-service-label-selected"}`}>Roofing</span>
                            </label>
                        </div>
                        <div className=" w-full flex  justify-center  md:ml-3 md:w-2/12 md:justify-start">
                            <label className={`p-2 w-2/5  mb-3 md:w-full  inline-flex items-center ${"Other" !== currentService ? "custom-radio-button-service" : "custom-radio-button-service-selected"}`}>
                                <input
                                    checked={"Other" === currentService ? true : false}
                                    disabled={disabledOther}
                                    type="radio" onChange={e => handleOnChange("Other", "fromBtn")} className="form-radio" name="serviceType" value="Other" />
                                <span className={`ml-2 ${"Other" !== currentService ? "custom-service-label" : "custom-service-label-selected"}`}>Other</span>
                            </label>
                        </div>
                    </div>
                    <div className="m-3 md:m-0 md:mt-5">

                        {serviceConfig?.map(currentService => renderService(serviceConfig, currentService))}

                    </div>
                    <div className="m-3 flex justify-center md:justify-end md:mr-10">
                        <button
                            onClick={cancelService}
                            className="font-bold text-customBlue custom-btn-preview-widget mb-3 md:mb-0 md:mr-5"
                        >Cancel</button>
                        {disableUpdateButton ? "" :
                            <button type="button"

                                onClick={handleAddNewService}
                                className="font-bold text-customBlue custom-btn-add-service"
                            >{labelButtonService}</button>}
                    </div>
                </div>
            </div>
        </div >
    )
}

export default Service;
